import { LOCALES, type Locale, useLocale } from "@/lib/i18n";

export function LanguageToggle({ className = "" }: { className?: string }) {
  const { locale, setLocale, t } = useLocale();
  return (
    <select
      aria-label={t.language}
      value={locale}
      onChange={(e) => setLocale(e.target.value as Locale)}
      className={`rounded-sm border border-border bg-panel-2 px-2 py-1 text-xs text-muted hover:text-text ${className}`}
    >
      {LOCALES.map((l) => (
        <option key={l.value} value={l.value}>
          {l.label}
        </option>
      ))}
    </select>
  );
}
